// import React from "react";
// import { MdClose } from "react-icons/md";

// const AdminSellerViewModal = ({ isOpen, onClose, seller }) => {
//   if (!isOpen || !seller) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
//       <div className="bg-[#ecf1f5] w-full max-w-2xl p-6 rounded-xl shadow-lg relative overflow-y-auto max-h-[90vh]">

//         {/* Close Button */}
//         <button
//           onClick={onClose}
//           className="absolute right-3 top-3 text-gray-600 hover:text-gray-800"
//         >
//           <MdClose size={22} />
//         </button>

//         <h2 className="text-2xl font-semibold text-center mb-4">
//           Seller Details
//         </h2>

//         {/* Seller Info */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

//           <div>
//             <p className="text-sm text-gray-500">Full Name</p>
//             <p className="font-semibold">{seller.fullName}</p>
//           </div>

//           <div>
//             <p className="text-sm text-gray-500">Mobile</p>
//             <p className="font-semibold">{seller.mobNo}</p>
//           </div>

//           <div>
//             <p className="text-sm text-gray-500">Email</p>
//             <p className="font-semibold">{seller.emailId}</p>
//           </div>

//           <div>
//             <p className="text-sm text-gray-500">Gender</p>
//             <p className="font-semibold">{seller.gender}</p>
//           </div>

//           <div className="md:col-span-2">
//             <p className="text-sm text-gray-500">Address</p>
//             <p className="font-semibold">{seller.address}</p>
//           </div>

//           <div>
//             <p className="text-sm text-gray-500">Business Name</p>
//             <p className="font-semibold">{seller.businessName}</p>
//           </div>

//           <div>
//             <p className="text-sm text-gray-500">Business Type</p>
//             <p className="font-semibold">{seller.businessType}</p>
//           </div>

//           <div>
//             <p className="text-sm text-gray-500">PAN Number</p>
//             <p className="font-semibold">{seller.panNo}</p>
//           </div>

//           <div>
//             <p className="text-sm text-gray-500">GSTIN</p>
//             <p className="font-semibold">{seller.gstIn}</p>
//           </div>

//           <div>
//             <p className="text-sm text-gray-500">Commission</p>
//             <p className="font-semibold">{seller.commission}%</p>
//           </div>

//           <div>
//             <p className="text-sm text-gray-500">Bulk Order Commission</p>
//             <p className="font-semibold">{seller.bulkOrderCommission}%</p>
//           </div>

//           <div>
//             <p className="text-sm text-gray-500">Status</p>
//             <p
//               className={`font-semibold ${
//                 seller.status === "Approved"
//                   ? "text-green-600"
//                   : seller.status === "Rejected"
//                   ? "text-red-600"
//                   : "text-yellow-600"
//               }`}
//             >
//               {seller.status}
//             </p>
//           </div>

//           <div className="md:col-span-2 mt-4">
//             <p className="text-sm text-gray-500">Shop Image</p>
//             <img
//               src={seller.shopImage}
//               alt="shop"
//               className="w-40 h-40 object-cover border rounded-lg shadow"
//             />
//           </div>
//         </div>

//         <div className="mt-6 flex justify-center">
//           <button
//             onClick={onClose}
//             className="px-6 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminSellerViewModal;

// AdminSellerViewPage.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { ArrowLeft, ShoppingBag } from "lucide-react";

const AdminSellerViewPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;

  const [seller, setSeller] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [productSearch, setProductSearch] = useState("");
  const [approving, setApproving] = useState(false);

  // Fetch seller details
  const fetchSeller = async () => {
    try {
      const res = await axios.get(`${API_URL}/supplier/suppliers-by-id/${id}`);
      setSeller(res.data.data);
    } catch {
      toast.error("Failed to load seller details");
    }
  };

  // Fetch seller's products
  const fetchProducts = async () => {
    try {
      const res = await axios.get(
        `${API_URL}/products/products-by-supplier/${id}`
      );
      // attach adminBlocked flag locally (or from your DB field if you add it)
      setProducts(
        (res.data.products || []).map((p) => ({
          ...p,
          adminBlocked: p.adminBlocked || false,
        }))
      );
    } catch {
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchSeller();
      fetchProducts();
    }
  }, [id]);

  // Approve seller
  const handleApprove = async () => {
    if (!seller || seller.status === "Approved") return;
    setApproving(true);
    try {
      await axios.put(`${API_URL}/supplier/change-suppliers-status/${id}`, {
        status: "Approved",
      });
      toast.success("Seller approved!");
      setSeller((prev) => ({ ...prev, status: "Approved" }));
    } catch {
      toast.error("Failed to approve seller");
    } finally {
      setApproving(false);
    }
  };

  // Block / Unblock product (updates stock_status to inactive to hide from users)
  const handleBlockToggle = async (product) => {
    const newBlocked = !product.adminBlocked;
    // Set stock_status to "inactive" when blocked so it's hidden on user side
    const newStockStatus = newBlocked ? "inactive" : "active";
    try {
      await axios.patch(
        `${API_URL}/products/change-stock-status/${product._id}`,
        { stock_status: newStockStatus }
      );
      toast.success(
        newBlocked ? "Product blocked from users" : "Product unblocked"
      );
      setProducts((prev) =>
        prev.map((p) =>
          p._id === product._id
            ? { ...p, adminBlocked: newBlocked, stock_status: newStockStatus }
            : p
        )
      );
    } catch {
      toast.error("Failed to update product visibility");
    }
  };

  const getName = (field) => {
    if (!field) return "—";
    if (typeof field === "string") return field;
    return field.en || Object.values(field)[0] || "—";
  };

  const filteredProducts = products.filter((p) => {
    const q = productSearch.toLowerCase();
    return (
      getName(p.name).toLowerCase().includes(q) ||
      (p.sku || "").toLowerCase().includes(q) ||
      (p.bhkg_id || "").toLowerCase().includes(q)
    );
  });

  const statusColor = {
    Approved: "text-green-600 bg-green-50",
    Pending: "text-yellow-600 bg-yellow-50",
    Rejected: "text-red-600 bg-red-50",
  };

  const stockColor = {
    active: "bg-green-100 text-green-700",
    inactive: "bg-gray-100 text-gray-600",
    "out of stock": "bg-red-100 text-red-700",
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-500">Loading seller details...</div>
      </div>
    );
  }

  if (!seller) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-500">Seller not found.</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#ecf1f5] px-4 md:px-10 py-6">
      {/* Back button */}
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-800 mb-6"
      >
        <ArrowLeft size={16} /> Back to sellers
      </button>

      {/* ── Section 1: Seller Info ── */}
      <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
        <div className="flex justify-between items-center mb-4 border-b pb-3">
          <h2 className="text-lg font-semibold">Seller Details</h2>
          <button
            onClick={handleApprove}
            disabled={seller.status === "Approved" || approving}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition ${
              seller.status === "Approved"
                ? "bg-green-100 text-green-700 cursor-default"
                : "bg-[#b07d17] text-white hover:bg-[#8c6312]"
            }`}
          >
            {seller.status === "Approved" ? "Approved" : approving ? "Approving..." : "Approve Seller"}
          </button>
        </div>

        {/* Shop image + name */}
        <div className="flex items-start gap-4 mb-4">
          <img
            src={seller.shopImage}
            alt={seller.fullName}
            className="w-20 h-20 object-cover rounded-xl border"
          />
          <div>
            <p className="text-lg font-semibold">{seller.fullName}</p>
            <p className="text-sm text-gray-500">{seller.businessName}</p>
            <span
              className={`text-xs font-medium px-3 py-0.5 rounded-full mt-1 inline-block ${
                statusColor[seller.status]
              }`}
            >
              {seller.status}
            </span>
          </div>
        </div>

        {/* Info grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            ["Mobile", seller.mobNo],
            ["Email", seller.emailId],
            ["Gender", seller.gender],
            ["Business Type", seller.businessType],
            ["Commission", `${seller.commission}%`],
            ["Bulk Order Commission", `${seller.bulkOrderCommission}%`],
            ["PAN Number", seller.panNo],
            ["GSTIN", seller.gstIn],
          ].map(([label, value]) => (
            <div key={label}>
              <p className="text-xs text-gray-400 uppercase tracking-wide mb-0.5">
                {label}
              </p>
              <p className="text-sm font-medium">{value}</p>
            </div>
          ))}
          <div className="col-span-2 md:col-span-4">
            <p className="text-xs text-gray-400 uppercase tracking-wide mb-0.5">
              Address
            </p>
            <p className="text-sm font-medium">{seller.address}</p>
          </div>
        </div>
      </div>

      {/* ── Section 2: Products Table ── */}
      <div className="bg-white rounded-xl shadow-sm p-6">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center gap-2">
            <ShoppingBag size={18} className="text-gray-500" />
            <h2 className="text-lg font-semibold">
              Products
              <span className="text-sm text-gray-400 font-normal ml-2">
                ({products.length} total)
              </span>
            </h2>
          </div>
          <input
            type="text"
            placeholder="Search products..."
            value={productSearch}
            onChange={(e) => setProductSearch(e.target.value)}
            className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm w-56 focus:outline-none focus:ring-1 focus:ring-blue-400"
          />
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-xs text-gray-500 uppercase">
              <tr>
                {["#", "Image", "Product", "SKU", "Category", "Price", "Stock", "Visibility", "Action"].map(
                  (h) => (
                    <th key={h} className="px-3 py-3 text-left font-semibold">
                      {h}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {filteredProducts.length === 0 ? (
                <tr>
                  <td colSpan={9} className="text-center py-8 text-gray-400">
                    No products found
                  </td>
                </tr>
              ) : (
                filteredProducts.map((p, i) => (
                  <tr key={p._id} className="border-t hover:bg-gray-50">
                    <td className="px-3 py-3">{i + 1}</td>
                    <td className="px-3 py-3">
                      {p.images?.[0] ? (
                        <img
                          src={p.images[0]}
                          alt=""
                          className="w-10 h-10 object-cover rounded-lg border"
                        />
                      ) : (
                        <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center text-gray-400 text-xs">
                          No img
                        </div>
                      )}
                    </td>
                    <td className="px-3 py-3">
                      <p className="font-medium max-w-[140px] truncate">
                        {getName(p.name)}
                      </p>
                      <p className="text-xs text-gray-400 font-mono">
                        {p.bhkg_id}
                      </p>
                    </td>
                    <td className="px-3 py-3 font-mono text-xs text-gray-500">
                      {p.sku}
                    </td>
                    <td className="px-3 py-3">
                      {p.category ? getName(p.category.name) : "—"}
                    </td>
                    <td className="px-3 py-3">₹{p.price?.toLocaleString()}</td>
                    <td className="px-3 py-3">
                      <span
                        className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                          stockColor[p.stock_status]
                        }`}
                      >
                        {p.stock_status}
                      </span>
                    </td>
                    <td className="px-3 py-3">
                      {p.adminBlocked && (
                        <span className="text-xs bg-red-50 text-red-600 px-2 py-0.5 rounded-full">
                          Blocked
                        </span>
                      )}
                    </td>
                    <td className="px-3 py-3">
                      <button
                        onClick={() => handleBlockToggle(p)}
                        className={`text-xs px-3 py-1 rounded-lg font-medium border transition ${
                          p.adminBlocked
                            ? "bg-green-50 text-green-700 border-green-200 hover:bg-green-100"
                            : "bg-red-50 text-red-700 border-red-200 hover:bg-red-100"
                        }`}
                      >
                        {p.adminBlocked ? "Unblock" : "Block"}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminSellerViewPage;